<button mat-stroked-button color="alert" (click)="onOpen()">
  <fa-icon [icon]="faLaptopBinary"></fa-icon>
  View Logic notes
</button>
